/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
// import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../_helpers";
import moment from "moment-timezone";
import CertificateLink from "../CertificateLink";
import getSymbolFromCurrency from "currency-symbol-map";
import DiamondTypeTag from "../Popup/DiamondTypeTag";

// function formattedDate(x) {
//     const originalTimestamp = new Date(x);
//     return originalTimestamp
// }

function numberWithCommas(x) {
    return x.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const shadeMappings = {
    "none": { label: "No.SH", tooltip: "Shade: NONE" },
    "brown": { label: "BR", tooltip: "Shade: Brown" },
    "light brown": { label: "L.BR", tooltip: "Shade: Light Brown" },
    "green": { label: "GR", tooltip: "Shade: Green" },
    "light green": { label: "L.GR", tooltip: "Shade: Light Green" },
    "grey": { label: "GREY", tooltip: "Shade: Grey" },
    "black": { label: "BLK", tooltip: "Shade: Black" },
    "pink": { label: "PINK", tooltip: "Shade: Pink" },
    "blue": { label: "BLUE", tooltip: "Shade: Blue" },
    "mix tinge": { label: "MIX", tooltip: "Shade: Mix Tinge" },
};

const renderShadeLabel = (shade) => {
    const mapping = shadeMappings[shade ? shade.toLowerCase() : ""];
    if (!mapping) return null;

    return (
        <span>
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip id="tooltip">{mapping.tooltip}</Tooltip>}
            >
                <span className={`label label-light-primary label-light-shade_${shade.toLowerCase().replace(' ', '_')} label-pill label-inline label-sm mr-1 font-weight-bold px-2`}>{mapping.label}</span>
            </OverlayTrigger>
        </span>
    );
};


export const MockDocTableColumn = (conversionrate,symbol,history,RouteToProforma,data,language,userinfo) =>{ 
    const columns = [
    {
        Header: language.CONFIRM_DIAMOND_ORDERNO,
        className: "align-middle text-center",
        accessor: (d) => {
            return (
                <>
                    <div className="text-break d-inline-block" style={{maxWidth:"150px",minWidth:"150px"}}>{d.conformGoodId || ""}</div>
                    <p className="m-0 small text-muted">
                        {/* {d.conformGoodId} */}
                        { d.created_date ? moment.tz(d.created_date, userinfo.timezone ? userinfo.timezone : Intl.DateTimeFormat().resolvedOptions().timeZone).format("YYYY-MM-DD HH:mm:ss") : "-"}
                    </p>
                </>
            );
        },
    },
    {
        Header: language.CONFIRM_DIAMOND_DIAMONDDETAILS,
        accessor: (d) => (
            <>
            {d.diamondType === "PN" || d.diamondType === "PL" ? 
                <div className="row">
                    <div className="col-2 text-center p-0">
                        <img
                            className="img-fluid mr-2"
                            alt={d.shape}
                            src={toAbsoluteUrl(`/media/shape/svg_shape/parcel/${d.shape.toLowerCase()}.svg`)}
                            width="50px"
                            onError={e => {
                                e.currentTarget.src = toAbsoluteUrl(
                                    `/media/shape/svg_shape/parcel/other.svg`
                                    )
                                }}
                        />
                    </div>
                    <div className="col-10 pl-2 p-0 text-left">
                        <div className={`mb-1 ${d.diamondType === "PN" ? "natTab" : "labTab"}`}>
                            <DiamondTypeTag diamondTypeTagColor={d.diamondTypeTagColor} diamondTypeTag={d.diamondTypeTag}/>
                            <span className={`cursor-pointer small ml-2`}>
                                {d.diamondType}-{d.stockID}
                            </span>
                            <span className={`text-capitalize small ml-2`}>
                                By: {d.parcelType === "carat" ? "Cts." : "Pcs."}
                            </span>
                            <span className={`text-capitalize small ml-2`}>
                            {d.parcelLength ? d.parcelLength.toFixed(2):"" }-{d.parcelWidth?d.parcelWidth.toFixed(2):"" } MM
                            </span>
                        </div>

                        <span className="text-dark font-weight-bold d-block">
                            {d.shape}{" "}
                            {d.weight ? d.weight.toFixed(2):""}Ct.{" "}
                            {d.parcelPieces}Pcs.{" "}
                            {d.color}{" "}
                            {d.clarity}{" "}
                        </span>
                    </div>
                </div>
             :
                <div className="row">
                    <div className="col-2 text-center p-0">
                        {d.image? (
                            <img
                                className="img-fluid mr-2"
                                alt={d.shape}
                                src={d.image}
                                width="50px"
                                onError={e => {
                                    e.currentTarget.src = toAbsoluteUrl(
                                        `/media/shape/${d.shape ? d.shape.toLowerCase() : ""}-no.png`
                                        )
                                    }}
                            />
                        ) : (
                            <img
                                className="img-fluid mr-2"
                                alt={d.shape}
                                src={toAbsoluteUrl(
                                    `/media/shape/${d.shape ? d.shape.toLowerCase() : ""}-no.png`
                                )}
                                onError={e => {
                                    e.currentTarget.src = toAbsoluteUrl(
                                        `/media/shape/noimage.jpg`
                                    )
                                }}
                                width="50px"
                                style={{ backgroundColor: "#f4f4f4" }}
                            />
                        )}
                    </div>
                    <div className="col-10 pl-2 p-0 text-left">
                        <div className={`mb-1 ${d.diamondType === "N" ? "natTab" : "labTab"}`}>
                            <DiamondTypeTag diamondTypeTagColor={d.diamondTypeTagColor} diamondTypeTag={d.diamondTypeTag}/>
                            <a href={`/details/confirm-${d.conformGoodId}`} target="_blank" rel="noreferrer" className={`cursor-pointer small ml-2`} >
                                {d.diamondType === "N" || d.diamondType === "W" ? "N" : "L"}-{d.stockID}
                            </a>
                            
                            <CertificateLink Certificate_link={d.certificate_link} lab={d.lab} certificate={d.certificate} className={`mx-2 small`} />
                        </div>

                        <span className="text-dark font-weight-bold d-block">
                            {d.shape}{" "}
                            {d.weight}{" "}
                            {d.color}{" "}
                            {d.clarity}{" "}{d.cut}{" "}{d.polish}{" "}{d.symmetry}{" "}
                            {d.fluorescence}
                        </span>
                    </div>
                </div> 
                }
            </>
        ),
        className: "text-center align-middle",
        disableSortBy: true,
    },
    
    {
        Header: language.CONFIRM_DIAMOND_LOCATIONANDDELIVERY,
        accessor: (d) => (
            <>
                {d.country}
                <br />
                <span className="text-muted small">{d.shippingDays} days</span>
            </>
        ),
        className: "text-center align-middle",
        disableSortBy: true,
    },
    {
        Header: "Advanced Tags",
        accessor: (d) => (
            <div className="advTag" style={{ maxWidth: "150px" }}>
                {/* shade */}
                {renderShadeLabel(d.shade)}
                
                { d.milky && d.milky.toLowerCase() === "no milky" ?
                    <span>
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip id="tooltip">
                                    NO MILKY
                                </Tooltip>
                            }
                        >
                            <span className="label label-light-no_milky label-pill label-inline label-sm  mr-1 font-weight-bold px-2">NO.ML</span>
                        </OverlayTrigger>
                    </span>
                :
                    null
                }

                { d.milky && d.milky.toLowerCase() === "luster low" ?
                    <span>
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip id="tooltip">
                                    Luster Low
                                </Tooltip>
                            }
                        >
                            <span className="label label-light-luster_low label-pill label-inline label-sm  mr-1 font-weight-bold px-2">LL</span>
                        </OverlayTrigger>
                    </span>
                :
                    null
                }

                { d.milky && d.milky.toLowerCase() === "light milky" ?
                    <span>
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip id="tooltip">
                                    LIGHT MILKY
                                </Tooltip>
                            }
                        >
                            <span className="label label-light-light_milky label-pill label-inline label-sm  mr-1 font-weight-bold px-2">L.ML</span>
                        </OverlayTrigger>
                    </span>
                :
                    null
                }

                { d.milky && d.milky.toLowerCase() === "milky" ?
                    <span>
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip id="tooltip">
                                    MILKY
                                </Tooltip>
                            }
                        >
                            <span className="label label-light-milky label-pill label-inline label-sm  mr-1 font-weight-bold px-2">H.ML</span>
                        </OverlayTrigger>
                    </span>
                :
                    null
                }

                {/* eyeclean */}
                { d.eyeClean && d.eyeClean.toLowerCase() === "yes" ?
                    <span>
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip id="tooltip">
                                    100% Eye Clean
                                </Tooltip>
                            }
                        >
                            <span className="label label-light-info label-pill label-inline label-sm  mr-1 font-weight-bold px-2">100% EC</span>
                        </OverlayTrigger>
                    </span>
                :
                    null
                }
                { d.eyeClean && d.eyeClean.toLowerCase() === "no" ?
                    <span>
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip id="tooltip">
                                    No Eye Clean
                                </Tooltip>
                            }
                        >
                            <span className="label label-light-danger label-pill label-inline label-sm  mr-1 font-weight-bold px-2">EC: NO</span>
                        </OverlayTrigger>
                    </span>
                :
                    null
                }

                {/* growthtype */}
                { d.diamondType === "L" && (d.growthType && d.growthType === "CVD") ?
                    <span>
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip id="tooltip">
                                    CVD
                                </Tooltip>
                            }
                        >
                            <span className="label label-light-success label-pill label-inline label-sm  mr-1 font-weight-bold px-2">CVD</span>
                        </OverlayTrigger>
                    </span>
                :
                    null
                }
                { d.diamondType === "L" && (d.growthType && d.growthType === "HPHT") ?
                    <span>
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip id="tooltip">
                                    HPHT
                                </Tooltip>
                            }
                        >
                            <span className="label label-light-success label-pill label-inline label-sm  mr-1 font-weight-bold px-2">HPHT</span>
                        </OverlayTrigger>
                    </span>
                :
                    null
                }
                
                { (d.diamondType === "L" ) && (d.treatment && d.treatment.toLowerCase() === "as grown") ? 
                    <span>
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip id="tooltip">
                                    As Grown
                                </Tooltip>
                            }
                        >
                            <span className="label label-light-success label-pill label-inline label-sm  font-weight-bold px-2">As-G</span>
                        </OverlayTrigger>
                    </span>
                : 
                    null
                }
                {/* natural treated */}
                { (d.diamondType === "N" || d.diamondType === "W") && (d.treatment && d.treatment.toLowerCase() !== "none")  ? 
                    <span>
                        <OverlayTrigger
                            placement="top"
                            overlay={
                                <Tooltip id="tooltip">
                                    Treated
                                </Tooltip>
                            }
                        >
                            <span className="label label-light-danger label-pill label-inline label-sm  font-weight-bold px-2">Tx</span>
                        </OverlayTrigger>
                    </span>
                : 
                    null
                }
            </div>
        ),
        className: "align-middle",
    },
    {
        Header: language.CONFIRM_DIAMOND_STATUS,
        accessor: (d) => (
            <div>
                <div
                    className={`label ${
                            d.diamondStatus === "Order Approve" ? "label-primary"
                            : d.diamondStatus === "Pending" ? "label-warning"
                            : d.diamondStatus === "Ready For Invoice" ? "label-success" 
                            : d.diamondStatus === "Ready to Ship" ? "label-success" 
                            : d.diamondStatus === "Rejected" ? "label-danger" 
                            : d.diamondStatus === "QC Rejected" ? "label-danger" 
                            : d.diamondStatus === "QC Review" ? "label-warning" 
                            : d.diamondStatus === "QC Approved" ? "label-success" 
                            : ""
                    } label-inline text-nowrap  mr-2`}
                >
                    {d.diamondStatus}
                </div>
            <br />
            {/* {d.proformaNo ? <Link to={{pathname:"proforma-detail",query:{proformaNo:d.proformaNo,conformGoodId:d.conformGoodId}}}  className="label label-light-info label-inline label-sm small" >Proforma generated</Link> : ""} */}
            {d.proformaNo ? <a onClick={() => RouteToProforma({query:{proformaNo:d.proformaNo,conformGoodId:d.conformGoodId}},data)} className="label label-light-info label-inline label-sm text-nowrap small">Pro Forma Inv No {d.perfoma_created_at}</a> : ""}
        
        </div>
        ),
        className: "text-center align-middle",
       
    },
    // {
    //     Header:'Diamond Journey',
    //     accessor:d => (
    //         <>
    //             <span className="font-weight-bolder">{d.canada_mark}</span><br />
    //             <span className="text-muted small">1-2 days</span>
    //         </>
    //       ),
    //     className:"text-center align-middle",
    // },
    {
        Header: language.CONFIRM_DIAMOND_DISCOUNT,
        className: "text-center text-danger align-middle",
        accessor: (d) => Number(d.discount).toFixed(2),
        sortMethod: (a, b) => Number(a) - Number(b),
        Cell: (row) => {
            return (
                <>
                    {row.row.original.diamondType === "PN" || row.row.original.diamondType === "PL" ? "-" :
                        <span className={`${(row.value >= 0) ? 'text-success' : 'text-danger'}`}>{row.value}%</span>
                    }
                </>
            );
        },
    }
];
    if(data?.[0]?.customerheadername){
        columns.push({
            id:"Purchase Price",
            Header: <span>{data?.[0]?.customerheadername || "Purchase Price"}</span>,
            accessor: (d) => (
                <>
                    <span className="font-weight-bold">
                        {d.ourPriceSymbol}{numberWithCommas(parseFloat(d["ourPrice"]))}
                    </span>{" "}
                    <br />
                    <span className="text-muted small">
                    {d.ourPriceSymbol}/CT {numberWithCommas(parseFloat(d["ourRate"]))}
                    </span>
                </>
            ),
            className: "text-right pr-12 align-middle",
        })
    }
    if (data?.[0]?.customerexchangeheadername) {
        columns.splice(7, 0, {
            Header: <span>{data?.[0]?.customerexchangeheadername || "Exchange Price"}</span>,
            id:"ourpriceothercurr",
            accessor: (d) => (
                <>
                        <OverlayTrigger
                            placement="top"
                            overlay={<Tooltip id="tooltip"> Ex. Rate : {d.ourPriceCustomerSymbolName} { d.ourPriceCustomerSymbol}{d.customerCurrencyRate}</Tooltip>}
                        >
                            <div>
                                <span className="font-weight-bold">
                                { d.ourPriceCustomerSymbol}{numberWithCommas(parseFloat(d["ourPriceCustomer"]))}
                                </span>{" "}
                                <br />
                                <span className="text-muted small">
                                {d.ourPriceCustomerSymbol}/CT {numberWithCommas(parseFloat(d["ourRateCustomer"]))}
                                </span>
                            </div>
                        </OverlayTrigger>
                        
                    </>
            ),
            className: "text-right pr-12 align-middle",
        });
    }
    columns.push({
        Header: language.CONFIRM_DIAMOND_TRACK,
        accessor: (d) => (
            <>
                {d["tracking"]}
            </>
        ),
        className: "text-center align-middle",
    })


    return columns;
}
